import React, { forwardRef } from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { IconButton, InputBase, Paper } from '@material-ui/core';
import { Tune as TuneIcon, Search as SearchIcon, Clear as ClearIcon } from '@material-ui/icons';
import { ru } from 'locale';
import useStyles from './SearchBox.styles';

const SearchBox = forwardRef(function SearchBox(props, ref) {
  const {
    value,
    clearable,
    showFilters,
    inputProps,
    onChange,
    onSearch,
    onClear,
    onFilterSelect,
  } = props;
  const classes = useStyles();

  const handleSearch = () => {
    if (value.length > 0) {
      onSearch();
    }
  };

  return (
    <Paper component="form" className={classes.searchBoxForm} square ref={ref}>
      <InputBase
        value={value}
        type="search"
        className={classes.searchBox}
        placeholder={ru.anketSearchNumber}
        onChange={onChange}
        inputProps={{
          role: 'combobox',
          autoCorrect: 'off',
          spellCheck: false,
          'aria-label': ru.anketSearch,
          ...inputProps,
        }}
        autoComplete="off"
        autoFocus={false}
        fullWidth
      />
      {clearable && value.length > 0 && (
        <IconButton className={classes.iconButton} aria-label={ru.clear} onClick={onClear}>
          <ClearIcon />
        </IconButton>
      )}
      <IconButton className={classes.iconButton} aria-label={ru.search} onClick={handleSearch}>
        <SearchIcon />
      </IconButton>
      {showFilters && (
        <IconButton className={classes.iconButton} aria-label={ru.filters} onClick={onFilterSelect}>
          <TuneIcon />
        </IconButton>
      )}
    </Paper>
  );
});

SearchBox.propTypes = {
  value: Type.string.isRequired,
  showFilters: Type.bool,
  clearable: Type.bool,
  inputProps: Type.object, // eslint-disable-line react/forbid-prop-types
  onChange: Type.func.isRequired,
  onSearch: Type.func.isRequired,
  onClear: Type.func.isRequired,
  onFilterSelect: Type.func,
};

SearchBox.defaultProps = {
  showFilters: false,
  clearable: true,
  inputProps: {},
  onFilterSelect: noop,
};

export default SearchBox;
